import { createFormFields } from '@/shared/components/form-fields/factories/create-form-fields';
import { useFieldContext } from './form-context.hook';

export const QuoteFormFields = createFormFields(useFieldContext);

export type {
  CalendarFieldProps,
  CheckboxFieldProps,
  DateFieldProps,
  NumberFieldProps,
  RadioButtonGroupProps,
  RadioButtonOption,
  SelectFieldOption,
  SelectFieldProps,
  TextareaFieldProps,
  TextFieldProps,
} from '@/shared/components/form-fields/factories/create-form-fields';
